
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0.9 0 21.1 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.021 5.536l3.394 3.394 3.395-3.394M11.416 1.01v7.92M9.654 13.332a3.991 3.991 0 11-7.983 0 3.991 3.991 0 017.983 0zM21.183 13.332a3.991 3.991 0 11-7.982 0 3.991 3.991 0 017.982 0zM5.664 17.322h11.53","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    